/**
 * @generated SignedSource<<c87a638f575f0d65a562fad6026c6e05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetCalendarOverviewEventUpdatedSubscription$variables = {
  calendarIds: ReadonlyArray<string>;
};
export type WidgetCalendarOverviewEventUpdatedSubscription$data = {
  readonly calendarEventUpdated: {
    readonly calendarEvent: {
      readonly createdAt: {
        readonly isoString: string;
      };
      readonly endAt: {
        readonly isoString: string;
      };
      readonly id: string;
      readonly isAllDayEvent: boolean;
      readonly startAt: {
        readonly isoString: string;
      };
      readonly " $fragmentSpreads": FragmentRefs<"WidgetCalendarOverviewEventItem_event">;
    };
  } | null;
};
export type WidgetCalendarOverviewEventUpdatedSubscription = {
  response: WidgetCalendarOverviewEventUpdatedSubscription$data;
  variables: WidgetCalendarOverviewEventUpdatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "calendarIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "calendarIds",
    "variableName": "calendarIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "startAt",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "endAt",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAllDayEvent",
  "storageKey": null
},
v9 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "DEFAULT"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
  }
],
v10 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "WEEKDAY_AND_DATE"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"WEEKDAY_AND_DATE\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetCalendarOverviewEventUpdatedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CalendarEventUpdatedPayload",
        "kind": "LinkedField",
        "name": "calendarEventUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarEvent",
            "kind": "LinkedField",
            "name": "calendarEvent",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetCalendarOverviewEventItem_event"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WidgetCalendarOverviewEventUpdatedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CalendarEventUpdatedPayload",
        "kind": "LinkedField",
        "name": "calendarEventUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarEvent",
            "kind": "LinkedField",
            "name": "calendarEvent",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreCalendar",
                "kind": "LinkedField",
                "name": "storeCalendar",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "startAtDateAndTime",
                "args": null,
                "concreteType": "StoreZonedDate",
                "kind": "LinkedField",
                "name": "startAt",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": "endAtDateAndTime",
                "args": null,
                "concreteType": "StoreZonedDate",
                "kind": "LinkedField",
                "name": "endAt",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": "startAtWeekdayAndDate",
                "args": null,
                "concreteType": "StoreZonedDate",
                "kind": "LinkedField",
                "name": "startAt",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              {
                "alias": "endAtWeekdayAndDate",
                "args": null,
                "concreteType": "StoreZonedDate",
                "kind": "LinkedField",
                "name": "endAt",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              {
                "alias": "endAtTime",
                "args": null,
                "concreteType": "StoreZonedDate",
                "kind": "LinkedField",
                "name": "endAt",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "style",
                        "value": "TIME_ONLY"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "storeFormattedDate",
                    "storageKey": "storeFormattedDate(style:\"TIME_ONLY\")"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b656af1e432e297aa1ab324627301bd6",
    "id": null,
    "metadata": {},
    "name": "WidgetCalendarOverviewEventUpdatedSubscription",
    "operationKind": "subscription",
    "text": "subscription WidgetCalendarOverviewEventUpdatedSubscription(\n  $calendarIds: [ID!]!\n) {\n  calendarEventUpdated(calendarIds: $calendarIds) {\n    calendarEvent {\n      id\n      startAt {\n        isoString\n      }\n      endAt {\n        isoString\n      }\n      createdAt {\n        isoString\n      }\n      isAllDayEvent\n      ...WidgetCalendarOverviewEventItem_event\n    }\n  }\n}\n\nfragment CalendarOverviewEventItemDateTime_event on CalendarEvent {\n  startAtDateAndTime: startAt {\n    isoString\n    ...StoreFormattedDate_2LP8ap\n  }\n  endAtDateAndTime: endAt {\n    isoString\n    ...StoreFormattedDate_2LP8ap\n  }\n  startAtWeekdayAndDate: startAt {\n    ...StoreFormattedDate_1hpjGt\n  }\n  endAtWeekdayAndDate: endAt {\n    ...StoreFormattedDate_1hpjGt\n  }\n  endAtTime: endAt {\n    ...StoreFormattedDate_1b2lNL\n  }\n  isAllDayEvent\n}\n\nfragment StoreFormattedDate_1b2lNL on StoreZonedDate {\n  storeFormattedDate(style: TIME_ONLY)\n}\n\nfragment StoreFormattedDate_1hpjGt on StoreZonedDate {\n  storeFormattedDate(style: WEEKDAY_AND_DATE)\n}\n\nfragment StoreFormattedDate_2LP8ap on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment WidgetCalendarOverviewEventItem_event on CalendarEvent {\n  title\n  storeCalendar {\n    color\n    id\n  }\n  ...CalendarOverviewEventItemDateTime_event\n}\n"
  }
};
})();

(node as any).hash = "f497a363e62317593f44f642215b224a";

export default node;
